{
	"savedCartDetails": {
		"cartName": "Name",
		"cartDescription": "Description",
		"cartId": "ID",
		"dateSaved": "Date Saved",
		"items": "Items",
		"quantity": "Quantity",
		"total": "Total",
		"editSavedCart": "Edit Saved Cart",
		"deleteSavedCart": "Delete Saved Cart",
		"addSelectedItems": "Add selected items",
		"emptyCartItems": "Empty Cart Items"
	},
	"savedCartList": {
		"savedCarts": "Saved Carts ({{count}})",
		"cartName": "Name",
		"cartId": "Id",
		"dateSaved": "Date Saved",
		"cartDescription": "Description",
		"quantity": "Qty",
		"total": "Total",
		"actions": "Actions",
		"makeCartActive": "Make cart active",
		"notFound": "No Saved Carts Found",
		"swapCartNoActiveCart": "Vorhandener Warenkorb wurde von {{cartName}} erfolgreich aktiviert.",
		"swapCartWithActiveCart": "Vorhandener Warenkorb wurde von {{cartName}} erfolgreich aktiviert. Ihre vorherigen Artikel wurden in einem Warenkorb {{previousCartName}} gespeichert."
	},
	"savedCartCartPage": {
		"messages": {
			"cartSaved": "Your cart items have been successfully saved for later in the \"{{cartName}}\" cart"
		}
	},
	"savedCartDialog": {
		"saveForLater": "Save for later",
		"itemsSavedForLater": "All of the items in your Cart will be saved for later",
		"savedCartName": "Saved Cart Name",
		"savedCartDescription": "Saved Cart Description",
		"optional": "optional",
		"charactersLeft": "characters left: {{count}}",
		"cancel": "Cancel",
		"save": "Save",
		"followingCartDelete": "Following saved cart will be deleted",
		"delete": "Delete",
		"deleteCartSuccess": "Cart Deleted Successfully",
		"editCartSuccess": "Cart Edited Successfully",
		"editSavedCart": "Edit Saved Cart",
		"deleteSavedCart": "Delete Saved Cart",
		"name": "Name",
		"id": "ID",
		"description": "Description",
		"quantity": "QTY",
		"total": "Total"
	},
	"addToSavedCart": {
		"savedCarts": "Gespeicherte Warenkörbe",
		"saveCartForLater": "Warenkorb speichern"
	}
}